export function cleanArtifactTags(text: string): string {
	const artifactTagSelfClosingRegex =
		/<object(?:\s+[a-zA-Z][a-zA-Z0-9_-]*="[^"]*"|\s+[a-zA-Z][a-zA-Z0-9_-]*='[^']*'|\s+[a-zA-Z][a-zA-Z0-9_-]*=[^\s>]*)*\s*\/>/gi;
	const artifactTagWithContentRegex =
		/<object(?:\s+[a-zA-Z][a-zA-Z0-9_-]*="[^"]*"|\s+[a-zA-Z][a-zA-Z0-9_-]*='[^']*'|\s+[a-zA-Z][a-zA-Z0-9_-]*=[^\s>]*)*\s*>[\s\S]*?<\/object>/gi;

	return text.replace(artifactTagSelfClosingRegex, "").replace(artifactTagWithContentRegex, "");
}
